import React, { lazy } from 'react';
import PermissionService from '@Services/PermissionService';
const UsersList = lazy(() => import('./components/usersList/UsersList'));

export const adminPanelConfig = [
	{
		auth: true,
		component: <UsersList />,
		name: 'userslist',
		path: '/admin/userslist',
		pm: (pm) => PermissionService(pm).getUsersList(),
	},
]